export default (value) => {
    if(Array.isArray(value)) {
        return value.join(", ");
    }
    
    return value;
}